// removed by extract-text-webpack-plugin
module.exports = {"number":"c-StepNumber__number","accent":"c-StepNumber__accent","withIcon":"c-StepNumber__withIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/StepNumber/StepNumber.scss
// module id = 794
// module chunks = 0